import * as i0 from '@angular/core';
import { Injectable, Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import * as i1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i3 from '@rogers/cdk/link';
import { LinkComponent } from '@rogers/cdk/link';
import * as i4 from '@rogers/cdk/icon';
import { IconComponent } from '@rogers/cdk/icon';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '@rogers/cdk/label';
function QuickLinkComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 1);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.headerTranslationKey));
  }
}
function QuickLinkComponent_For_4_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-icon", 5);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const link_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("name", "open-new")("caption", i0.ɵɵpipeBind1(1, 2, link_r3.openInNewTabAltText));
  }
}
function QuickLinkComponent_For_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function QuickLinkComponent_For_4_Conditional_0_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const link_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onClick(link_r3));
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, QuickLinkComponent_For_4_Conditional_0_Conditional_5_Template, 2, 4, "ds-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("target", ctx_r0.getTarget(link_r3));
    i0.ɵɵattribute("href", i0.ɵɵpipeBind1(1, 5, link_r3.url), i0.ɵɵsanitizeUrl)("title", link_r3.showLinkAltText ? i0.ɵɵpipeBind1(2, 7, link_r3.linkAltText) : "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 9, link_r3.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(5, link_r3.openInNewTab ? 5 : -1);
  }
}
function QuickLinkComponent_For_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function QuickLinkComponent_For_4_Conditional_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const link_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onClick(link_r3));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r0.getRouterLink(link_r3));
    i0.ɵɵattribute("role", ctx_r0.getRole(link_r3))("title", link_r3.showLinkAltText ? i0.ɵɵpipeBind1(1, 4, link_r3.linkAltText) : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, link_r3.label), "");
  }
}
function QuickLinkComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, QuickLinkComponent_For_4_Conditional_0_Template, 6, 11, "a", 3)(1, QuickLinkComponent_For_4_Conditional_1_Template, 4, 8);
  }
  if (rf & 2) {
    const link_r3 = ctx.$implicit;
    i0.ɵɵconditional(0, link_r3.isExternalLink ? 0 : 1);
  }
}
let QuickLinkService = /*#__PURE__*/(() => {
  class QuickLinkService {
    constructor(translateService) {
      this.translateService = translateService;
    }
    getQuickLinks$(..._args) {}
    handleLinkClick(link) {
      if (link.useCallback) {
        const url = !!link.urlTranslationKey ? this.translateService.instant(link.urlTranslationKey) : link.url;
        link.callback(url);
      }
    }
    /** @nocollapse */
    static {
      this.ɵfac = function QuickLinkService_Factory(t) {
        return new (t || QuickLinkService)(i0.ɵɵinject(i1.TranslateService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: QuickLinkService,
        factory: QuickLinkService.ɵfac
      });
    }
  }
  return QuickLinkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let QuickLinkComponent = /*#__PURE__*/(() => {
  class QuickLinkComponent {
    constructor(quickLinkService) {
      this.quickLinkService = quickLinkService;
      this.showHeader = true;
      this.headerTranslationKey = 'quick-links.header';
    }
    onClick(link) {
      this.quickLinkService.handleLinkClick(link);
    }
    getTarget(link) {
      return link.openInNewTab ? '_blank' : '_self';
    }
    getRole(link) {
      return link.isModal ? 'button' : 'link';
    }
    getRouterLink(link) {
      return link.url ? [link.url] : [];
    }
    /** @nocollapse */
    static {
      this.ɵfac = function QuickLinkComponent_Factory(t) {
        return new (t || QuickLinkComponent)(i0.ɵɵdirectiveInject(QuickLinkService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: QuickLinkComponent,
        selectors: [["ss-quick-links"]],
        inputs: {
          quickLinks: "quickLinks",
          showHeader: "showHeader",
          headerTranslationKey: "headerTranslationKey"
        },
        decls: 5,
        vars: 1,
        consts: [[1, "d-flex", "flex-column"], [1, "text-title-3", "mb-0"], [1, "quick-links"], ["ds-link", "", 1, "quick-link", 3, "target"], ["ds-link", "", 1, "quick-link", 3, "click", "target"], [1, "right", 3, "name", "caption"], ["ds-link", "", 1, "quick-link", 3, "click", "routerLink"]],
        template: function QuickLinkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0);
            i0.ɵɵtemplate(1, QuickLinkComponent_Conditional_1_Template, 3, 3, "h2", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵrepeaterCreate(3, QuickLinkComponent_For_4_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.showHeader ? 1 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.quickLinks);
          }
        },
        dependencies: [i2.RouterLink, i3.LinkComponent, i4.IconComponent, i1.TranslatePipe],
        styles: ["@-ms-viewport{width:device-width}.quick-links{display:flex;justify-content:space-between;margin-top:8px}@media (max-width: 599.98px){.quick-links{flex-direction:column}}@media (min-width: 600px){.quick-links{flex-flow:row wrap;align-items:baseline}}@media (min-width: 600px) and (max-width: 899.98px){.quick-links .quick-link{flex:0 0 calc(50vw - 40px)}}@media (max-width: 599.98px){.quick-links .quick-link{flex:1}}\n"],
        encapsulation: 2
      });
    }
  }
  return QuickLinkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let QuickLinksModule = /*#__PURE__*/(() => {
  class QuickLinksModule {
    /** @nocollapse */static {
      this.ɵfac = function QuickLinksModule_Factory(t) {
        return new (t || QuickLinksModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: QuickLinksModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, RouterModule, LinkComponent, LabelComponent, IconComponent]
      });
    }
  }
  return QuickLinksModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { QuickLinkComponent, QuickLinkService, QuickLinksModule };
